module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00312.3f170beb.jpg";